import defaultChitCardImage from '../assets/Images/Chits/chit-card-default.png';

/**
 * Prefer API image (img_Url / img_url); else same default as chitbid_2.0 web.
 */
export function getChitCardImage(source) {
  if (source == null) return defaultChitCardImage;
  if (typeof source === 'string') {
    const url = source.trim();
    return url || defaultChitCardImage;
  }
  const url = String(source.img_Url || source.img_url || '').trim();
  return url || defaultChitCardImage;
}

export { defaultChitCardImage };
